/**
 * Booking status enum
 */
export enum BookingStatus {
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  ACTIVE = 'active',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
}

/**
 * Booking interface matching Firestore schema
 */
export interface Booking {
  id: string;
  userId: string;
  bikeId: string;
  locationId: string;
  startTime: Date;
  endTime: Date;
  rentalType: 'half-day' | 'full-day' | 'multi-day'; // rental duration type
  numberOfDays?: number; // for multi-day rentals
  status: BookingStatus;
  halfDayRate: number; // in cents (snapshot at booking time)
  fullDayRate: number; // in cents (snapshot at booking time)
  appliedDiscount?: number; // discount percentage applied
  totalPrice: number; // in cents (after discount)
  insuranceIncluded: boolean;
  insurancePrice?: number; // in cents
  insuranceProvider?: 'oyster' | 'other';
  insurancePolicyId?: string; // Oyster policy ID if purchased
  insuranceQuoteId?: string; // Oyster quote ID if quoted
  paymentId?: string;
  qrCode?: string;
  checkInTime?: Date;
  checkOutTime?: Date;
  notes?: string;
  createdAt: Date;
  updatedAt: Date;
}

